import { Translations } from '@thoughtspot/i18n/translations';

export interface ChecklistSubtask {
    id: string;
    name: string;
    description?: string;
    url?: string;
    primary_button_configuration?: {
        text: Translations['keys'];
        event_id: string;
    };
    secondary_button_configuration?: {
        text: string;
        event_id: string;
    };
    media_urls?: string[];
    completed?: boolean;
    dom_paths?: string[];
}

export enum ChecklistTaskNavigationType {
    SPOTTER = 'SPOTTER',
    SPOTTER_VIZ = 'SPOTTER_VIZ',
    PLAYGROUND = 'PLAYGROUND',
    LIVEBOARD = 'LIVEBOARD',
    THOUGHTSPOT_PLUGINS = 'THOUGHTSPOT_PLUGINS',
    HOME = 'HOME',
    CONNECT_OWN_DATA = 'CONNECT_OWN_DATA',
    MODEL = 'MODEL',
    DEVELOPER_HOME = 'DEVELOPER_HOME',
    SECURITY_SETTINGS = 'SECURITY_SETTINGS',
}

export interface ChecklistTaskType {
    id: string;
    name: Translations['keys'];
    description?: Translations['keys'];
    type?: ChecklistTaskNavigationType;
    primary_button_configuration?: {
        text: Translations['keys'];
        event_id: string;
    };
    secondary_button_configuration?: {
        text: string;
        event_id: string;
    };
    media_urls?: string[];
    sub_tasks?: ChecklistSubtask[];
    completed?: boolean;
}

export interface ChecklistItem {
    id: string;
    name: Translations['keys'];
    description: Translations['keys'];
    tasks: ChecklistTaskType[];
}

export interface ChecklistModalProps {
    checklistItems: ChecklistItem[];
    checklistOpen: boolean;
    setChecklistOpen: (open: boolean) => void;
    checklistButtonRef: React.RefObject<HTMLButtonElement>;
    checkedItems: Set<string>;
    onTaskAction?: (event: string, type?: ChecklistTaskNavigationType) => void;
    onChecklistTaskButtonClick: (type: string, checkboxId: string) => void;
    headerExpandedItemsIndexes: number[];
    handleSectionHeaderClick: (expandedIndexes: number[]) => void;
    taskExpandedState: Record<string, number[]>;
    handleTaskHeaderClick: (
        sectionId: string,
        expandedIndexes: number[],
    ) => void;
    onCloseChecklist?: () => void;
    lastCompletedTaskId?: string | null;
}
